import { applyThemeComponents, applyThemePalette, applyThemeTypography, basePaletteOptions } from './baseConfig';
var theme;
theme = applyThemePalette(basePaletteOptions);
theme = applyThemeTypography(theme);
theme = applyThemeComponents(theme);
export default theme;
